import useAppDispatch from "@/hooks/useAppDispatch";
import Alert from "@/components/ui/Alert";
import type { CartError } from "@/types/cart";
import type { AlertItem } from "@/types/alert";
import { decodeHTMLEntity } from "@/utils/utils";

interface CartErrorsProps {
  errors: CartError[];
}

const CartErrors = ({ errors }: CartErrorsProps) => {
  const appDispatch = useAppDispatch();

  if (errors.length === 0) {
    return null;
  }

  const transformedErrors: AlertItem[] = errors.map((error, index) => {
    return {
      id: index,
      type: "warning",
      title: decodeHTMLEntity(error.message),
      autoClose: false,
    };
  });

  const handleRemoveError = (removeIndex: number) => {
    appDispatch.removeCartError(removeIndex);
  };

  return (
    <div className="mb-2 space-y-1">
      {transformedErrors.map((error, index) => (
        <Alert key={index} message={error} onRemove={() => handleRemoveError(index)} />
      ))}
    </div>
  );
};

export default CartErrors;
